import { Stack } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { sectionGap, stackedClassName } from './mdConsts';

const MDWrapper: React.FC<PropsWithChildren> = ({ children = null }) => (
	<Stack
		data-testid="md-renderer-wrapper"
		className={stackedClassName}
		gap={sectionGap}
	>
		{children}
	</Stack>
);

export default MDWrapper;
